export function addToFirstPlace<T>(arr: T[], newItem: T, maxItems: number|null = null): T[] {
    let list = [newItem, ...arr];
    if (maxItems) { list = list.slice(0, maxItems); }
    return list;
}
